<template>
  <main id="home">
	<hero />
  <specs />
  <Article />
	<green-home />
	<benefits />
	<opportunity />
	<howitworks />
	<ourteam />
	<invest />
	<system />
	<disclaimer />
  </main>
  <Footer />
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Benefits from '../components/benefits.vue';
import Hero from '../components/hero.vue';
import Howitworks from '../components/howitworks.vue';
import Ourteam from '../components/ourteam.vue';
import Opportunity from '../components/opportunity.vue';
import Invest from '../components/invest.vue';
import Footer from '../components/footer.vue';
import Disclaimer from '../components/disclaimer.vue';
import Specs from '../components/specs.vue';
import System from '../components/system.vue';
import GreenHome from '../components/green-home.vue';
import Article from '../components/article.vue';
import lastCampaign from 'last-campaign';

export default {
  name: 'Home',
  data() {
    return {
    };
  },
  components: {
    Benefits,
    Hero,
    Howitworks,
    Ourteam,
    Opportunity,
    Invest,
    Footer,
    Disclaimer,
    Specs,
    System,
    GreenHome,
    Article,
  },
  mounted() {
  lastCampaign({
    timeout: 60
  });
}
};
</script>
